import React, {useEffect, useContext} from "react";
import $ from 'jquery'
import MoveHandle from "../../assets/images/move-handle.svg";
import FloContext from "../contexts/floContext";
import ContentEditor from "../editor/editor";

export default function Steps(props: any) {
   const {steps, onSort}: any = useContext(FloContext);
   const sortableList = React.useRef(null);

   const enableSort = function () {
     const sortable = $((sortableList.current) as any);
      sortable.sortable({
         axis: "y",
         stop: function( event: any, ui: any ) {
            const order = sortable.sortable( "toArray" );
            sortable.sortable( "cancel" );
            onSort(order, steps);
         }
      });
   }

   useEffect(() => {
      enableSort();
   }, [])

   return(
       <div className="steps">
          <div className="flex hr-right margin-b-30">
             <div className="icon thrash margin-r-20">
                <img src={require('../../assets/images/thrash.png')} alt=""/>
             </div>
             <button className="btn item-height-40 round-corner-8">
                <div className="flex hr-center">
                   <div className="icon width-16">
                      <img src={require('../../assets/images/share.png')} alt=""/>
                   </div>
                   <div className="margin-l-5 font-14">Share</div>
                </div>
             </button>
          </div>

          <div className="rubik-medium font-18 margin-b-10">Steps: 9</div>

          <ul ref={sortableList} className="steps-list font-14 grey-color">
             {
                steps.map((step: any, index: number) => {
                   return(
                       <li id={index.toString()} key={index} className="flex hr-space-between">
                          <div className="content flex hr-space-between">
                             <div className="index blue-color rubik-medium">{index + 1}.</div>
                             <div className="step-name text-ellipsis">
                                <ContentEditor step={step} readOnly={true} />
                                {/*{step.name}*/}
                             </div>
                          </div>
                          <div className="icon drag-icon">
                             <img src={MoveHandle} alt=""/>
                          </div>
                       </li>
                   )
                })
             }

          </ul>
       </div>
   )
}
